import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class PharmacyActionStore {

  @observable action = false;
  @observable errors = {};
  @observable daw_review = [];
  @observable daw_review_code = {};
  @observable duplicate_participants_count = 0;
  @observable duplicate_participants_cost = 0;
  @observable duplicate_participants = [];
  @observable benzoUseTopDrugsRxFilled = [];
  @observable benzoUseTopProvidersRxFilled = [];
  @observable benzoUseTopPharmaciesRxFilled = [];
  @observable MedicalPharmacyBoxes = [];
  @observable MedicalPharmacyJCodeList = [];
  @observable opioidUseTopDrugsRxFilled = [];
  @observable opioidUseTopProvidersRxFilled = [];
  @observable opioidUseTopPharmaciesRxFilled = [];

  @observable PharmacySavingsBox = [];
  @observable AlternateFundingBox = [];
  @observable InternationalRxBox = [];
  @observable RxTourismBox = [];
  @observable PrecisionPgxBox = [];
  @observable SpecialtyReviewBox = [];
  @observable RebatesManagementBox = [];
  @observable PharmacySavingsBreakdown = [];
  @observable AlternateFundingBreakdown = [];
  @observable InternationalRxBreakdown = [];
  @observable RxTourismBreakdown = [];
  @observable PrecisionPgxBreakdown = [];
  @observable SpecialtyReviewBreakdown = [];
  @observable RebatesManagementBreakdown = [];

  @observable AllPolyPharmacy = [];
  @observable PlusTwoDrugs = [];
  @observable PlusFiveDrugs = [];
  @observable PlusEightDrugs = [];

  @observable url = "/api/v1/pharmacyAction";
  @observable duplicate_count = 0;
  @observable duplicate_cost = 0;
  @action setErrors = () => {
    this.errors = {};
  };

  @action setAction = action => {
    this.action = action;
  };

  //updated pharmacy action report store methods
  @action getParticipantsDuplicateEligibilityRecords = async data => {
    this.duplicate_participants_count = 0;
    const response = await post(
      `${this.url}/getParticipantsDuplicateEligibilityRecords`, data
    );
    this.duplicate_participants_count = response.data[0].duplicate_count;
  }
  @action getTotalSpendDuplicateRecords = async data => {
    this.duplicate_participants_cost = 0
    const response = await post(
      `${this.url}/getTotalSpendDuplicateRecords`, data
    );
    this.duplicate_participants_cost = response.data[0].duplicate_cost;
  }
  @action getDuplicateParticipantsTotalRxFilled = async data => {
    this.duplicate_participants = []
    const response = await post(
      `${this.url}/getDuplicateParticipantsTotalRxFilled`, data
    );
    this.duplicate_participants = response.data
  }
  @action getDawReviewRxFilled = async data => {
    this.daw_review = [];
    const response = await post(
      `${this.url}/getDawReviewRxFilled`, data
    );
    this.daw_review = response.data
    let temp = {};
    for (const val of response.data) {
      temp[`d${val.daw_code}`] = val.COST
    }
    this.daw_review_code = temp
  }
  @action getOpioidUseTopPharmaciesRxFilled = async data => {
    this.opioidUseTopPharmaciesRxFilled = [];
    const response = await post(
      `${this.url}/getOpioidUseTopPharmaciesRxFilled`, data
    );
    this.opioidUseTopPharmaciesRxFilled = response.data
  }
  @action getOpioidUseTopProvidersRxFilled = async data => {
    this.opioidUseTopProvidersRxFilled = [];
    const response = await post(
      `${this.url}/getOpioidUseTopProvidersRxFilled`, data
    );
    this.opioidUseTopProvidersRxFilled = response.data
  }
  @action getOpioidUseTopDrugsRxFilled = async data => {
    this.opioidUseTopDrugsRxFilled = [];
    const response = await post(
      `${this.url}/getOpioidUseTopDrugsRxFilled`, data
    );
    this.opioidUseTopDrugsRxFilled = response.data
  }
  @action getBenzoUseTopPharmaciesRxFilled = async data => {
    this.benzoUseTopPharmaciesRxFilled = [];
    const response = await post(
      `${this.url}/getBenzoUseTopPharmaciesRxFilled`, data
    );
    this.benzoUseTopPharmaciesRxFilled = response.data
  }
  @action getBenzoUseTopProvidersRxFilled = async data => {
    this.benzoUseTopProvidersRxFilled = [];
    const response = await post(
      `${this.url}/getBenzoUseTopProvidersRxFilled`, data
    );
    this.benzoUseTopProvidersRxFilled = response.data
  }
  @action getBenzoUseTopDrugsRxFilled = async data => {
    this.benzoUseTopDrugsRxFilled = [];
    const response = await post(
      `${this.url}/getBenzoUseTopDrugsRxFilled`, data
    );
    this.benzoUseTopDrugsRxFilled = response.data
  }

  @action getMedicalPharmacyBoxes = async data => {
    this.MedicalPharmacyBoxes = [];
    const response = await post(
      `${this.url}/getMedicalPharmacyBoxes`, data
    );
    this.MedicalPharmacyBoxes = response.data[0]
  }

  @action getMedicalPharmacyJCodeList = async data => {
    this.MedicalPharmacyJCodeList = [];
    const response = await post(
      `${this.url}/getMedicalPharmacyJCodeList`, data
    );
    this.MedicalPharmacyJCodeList = response.data
  }

  //New Store Actions for Boxes and Breakdown Sections

  @action getPharmacySavingsBox = async data => {
    this.PharmacySavingsBox = [];
    const response = await post(
      `${this.url}/getPharmacySavingsBox`, data
    );
    this.PharmacySavingsBox = response.data[0]
  }
  @action getAlternateFundingBox = async data => {
    this.AlternateFundingBox = [];
    const response = await post(
      `${this.url}/getAlternateFundingBox`, data
    );
    this.AlternateFundingBox = response.data[0]
  }
  @action getInternationalRxBox = async data => {
    this.InternationalRxBox = [];
    const response = await post(
      `${this.url}/getInternationalRxBox`, data
    );
    this.InternationalRxBox = response.data[0]
  }
  @action getRxTourismBox = async data => {
    this.RxTourismBox = [];
    const response = await post(
      `${this.url}/getRxTourismBox`, data
    );
    this.RxTourismBox = response.data[0]
  }
  @action getPrecisionPgxBox = async data => {
    this.PrecisionPgxBox = [];
    const response = await post(
      `${this.url}/getPrecisionPgxBox`, data
    );
    this.PrecisionPgxBox = response.data[0]
  }
  @action getSpecialtyReviewBox = async data => {
    this.SpecialtyReviewBox = [];
    const response = await post(
      `${this.url}/getSpecialtyReviewBox`, data
    );
    this.SpecialtyReviewBox = response.data[0]
  }
  @action getRebatesManagementBox = async data => {
    this.RebatesManagementBox = [];
    const response = await post(
      `${this.url}/getRebatesManagementBox`, data
    );
    this.RebatesManagementBox = response.data[0]
  }
  @action getPharmacySavingsBreakdown = async data => {
    this.PharmacySavingsBreakdown = [];
    const response = await post(
      `${this.url}/getPharmacySavingsBreakdown`, data
    );
    this.PharmacySavingsBreakdown = response.data
  }
  @action getAlternateFundingBreakdown = async data => {
    this.AlternateFundingBreakdown = [];
    const response = await post(
      `${this.url}/getAlternateFundingBreakdown`, data
    );
    this.AlternateFundingBreakdown = response.data
  }
  @action getInternationalRxBreakdown = async data => {
    this.InternationalRxBreakdown = [];
    const response = await post(
      `${this.url}/getInternationalRxBreakdown`, data
    );
    this.InternationalRxBreakdown = response.data
  }
  @action getRxTourismBreakdown = async data => {
    this.RxTourismBreakdown = [];
    const response = await post(
      `${this.url}/getRxTourismBreakdown`, data
    );
    this.RxTourismBreakdown = response.data
  }
  @action getPrecisionPgxBreakdown = async data => {
    this.PrecisionPgxBreakdown = [];
    const response = await post(
      `${this.url}/getPrecisionPgxBreakdown`, data
    );
    this.PrecisionPgxBreakdown = response.data
  }
  @action getSpecialtyReviewBreakdown = async data => {
    this.SpecialtyReviewBreakdown = [];
    const response = await post(
      `${this.url}/getSpecialtyReviewBreakdown`, data
    );
    this.SpecialtyReviewBreakdown = response.data
  }
  @action getRebatesManagementBreakdown = async data => {
    this.RebatesManagementBreakdown = [];
    const response = await post(
      `${this.url}/getRebatesManagementBreakdown`, data
    );
    this.RebatesManagementBreakdown = response.data
  }
  //PolyPharmacy boxes
  @action getAllPolyPharmacy = async data => {
    this.AllPolyPharmacy = [];
    const response = await post(
      `${this.url}/getAllPolyPharmacy`, data
    );
    this.AllPolyPharmacy = response.data[0]
  }
  @action getPlusTwoDrugs = async data => {
    this.PlusTwoDrugs = [];
    const response = await post(
      `${this.url}/getPlusTwoDrugs`, data
    );
    this.PlusTwoDrugs = response.data[0]
  }
  @action getPlusFiveDrugs = async data => {
    this.PlusFiveDrugs = [];
    const response = await post(
      `${this.url}/getPlusFiveDrugs`, data
    );
    this.PlusFiveDrugs = response.data[0]
  }
  @action getPlusEightDrugs = async data => {
    this.PlusEightDrugs = [];
    const response = await post(
      `${this.url}/getPlusEightDrugs`, data
    );
    this.PlusEightDrugs = response.data[0]
  }
}

export default PharmacyActionStore;